import { Header } from "../component/home/Header";
import { Footer } from "../component/home/Footer";
// import { ChatbotWidget } from "../component/home/ChatbotWidget";
import { CtaBanner } from "../component/about-us/CtaBanner";
import { Hero } from "../component/services/Hero";
import { LoanOptions } from "../component/services/LoanOptions";
import { WhyChooseUs } from "../component/services/WhyChooseUs";
import { Eligibility } from "../component/services/Eligibility";
import { SecurityNote } from "../component/services/SecurityNote";

export function ServicesPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <Hero />
        <LoanOptions />
        <WhyChooseUs />
        <Eligibility />
        <SecurityNote />
        <CtaBanner />
      </main>

      <Footer />
      {/* <ChatbotWidget /> */}
    </div>
  );
}
